import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { puedeAccederEstadisticasAvanzadas } from 'src/app/services/estadisticas/estadisticas-avanzadas.guard';

interface StatItem {
    title: string;
    desc: string;
    icon: string;
    color: string;
    route: string;
    enDesarrollo?: boolean;
    requierePermiso?: boolean;
}

@Component({
    selector: 'app-estadisticas-sistema',
    templateUrl: './estadisticas-sistema.component.html',
    styleUrls: ['./estadisticas-sistema.component.scss']
})
export class EstadisticasSistemaComponent implements OnInit {

    items: StatItem[] = [
        {
            title: 'Estadísticas de Centros Médicos',
            desc: 'Totales y distribución de centros por provincia, localidad, rubro, especialidad y gerenciadora.',
            icon: 'fas fa-hospital',
            color: '#0d6efd',
            route: '/padrones/estadisticas-centros',
        },
        {
            title: 'Estadísticas de Solicitudes y Usuarios',
            desc: 'Solicitudes por estado, tiempos de resolución, actividad por usuario y cobertura del padrón.',
            icon: 'fas fa-users-cog',
            color: '#f59e0b',
            route: '/estadisticas-sistema/solicitudes-usuarios',
            requierePermiso: true,
        },
        {
            title: 'Estadísticas de Credenciales Vistas',
            desc: 'Volumen de consultas de credenciales contra GECROS por día, semana, mes o año.',
            icon: 'fas fa-id-badge',
            color: '#0288d1',
            route: '/estadisticas-sistema/credenciales',
            requierePermiso: true,
        },
    ];

    constructor(private authService: AuthService) { }

    async ngOnInit(): Promise<void> {
        const email = await this.authService.getEmail();
        if (!puedeAccederEstadisticasAvanzadas(email)) {
            this.items = this.items.filter((item) => !item.requierePermiso);
        }
    }

    trackByTitle(index: number, item: StatItem): string {
        return item.title;
    }
}
